import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimUploadPriceFilesMutationVariables } from 'gql/graphql';
import { useSetIsWorkOrderChangeRequired } from 'pages/Project/BimProject/hooks/useSetIsWorkOrderChangeRequired';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimUploadPriceFilesGql } from '../../bimWorkOrderQueries';

const requestId = 'bimUploadPriceFiles';

export const useBimUploadPriceFiles = (onSuccess: (eventId: string) => void) => {
    const dispatch = useDispatch();
    const [bimUploadPriceFilesData, bimUploadPriceFilesStatus, bimUploadPriceFilesError, makeRequest, , abortRequest] =
        useRequest({
            requestId,
            query: bimUploadPriceFilesGql,
            withEffect: false,
            dependenciesUpdater: () => {
                onSuccess('rim_estimates_add button popped up_success');
            },
        });

    useSetIsWorkOrderChangeRequired({
        useData: bimUploadPriceFilesData?.bimUploadPriceFiles?.data,
        status: bimUploadPriceFilesStatus,
    });

    const [bimUploadPriceFilesReset] = useResetStoreData({ requestId });

    const bimUploadPriceFilesMakeRequest = useCallback(
        (variables: BimUploadPriceFilesMutationVariables) => {
            dispatch(makeRequest(variables));
        },
        [dispatch, makeRequest],
    );

    const bimUploadPriceFilesAbortRequest = useCallback(() => {
        dispatch(abortRequest());
    }, [abortRequest, dispatch]);

    return {
        bimUploadPriceFilesData: bimUploadPriceFilesData?.bimUploadPriceFiles,
        bimUploadPriceFilesStatus,
        bimUploadPriceFilesError,
        bimUploadPriceFilesReset,
        bimUploadPriceFilesMakeRequest,
        bimUploadPriceFilesAbortRequest,
    };
};
